import styled, { css } from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { AdminStatus } from '@/models/admins.model';

const getStylesByStatus = (status?: AdminStatus) => {
  switch (status) {
    case AdminStatus.ACTIVE:
      return css`
        background: ${COLORS.GREEN_OLIVE};
        color: ${COLORS.DARK_GREEN_PALE};
      `;
    case AdminStatus.DEACTIVATED:
    default:
      return css`
        background: ${COLORS.GREY_FADED_A};
        color: ${COLORS.GREY_FADED};
      `;
  }
};

export const StyledTag = styled.div<{ $status?: AdminStatus }>`
  padding: 0.25rem;
  border-radius: 0.25rem;
  width: fit-content;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${({ $status }) => getStylesByStatus($status)}
`;
